import { StockClass, useDeleteShareClass } from '@commenda/api';
import { DeleteConfirmationModal } from '../../../molecules';
import { friendlyOwnershipMessage } from '../forms/applyOwnershipApiError';

interface DeleteShareClassConfirmProps {
  isOpen: boolean;
  onClose: () => void;
  corporationId: number;
  shareClass?: StockClass;
  classNounLower: string;
  onSuccess?: (message: string) => void;
  onError?: (message: string) => void;
}

export const DeleteShareClassConfirm = ({
  isOpen,
  onClose,
  corporationId,
  shareClass,
  classNounLower,
  onSuccess,
  onError,
}: DeleteShareClassConfirmProps) => {
  const mutation = useDeleteShareClass(corporationId);

  const handleConfirm = async () => {
    if (!shareClass) return;
    try {
      await mutation.mutateAsync(shareClass.id);
      onSuccess?.(`Deleted ${shareClass.name}.`);
    } catch (err) {
      // The modal closes on a resolved promise and stays open on a rejection, which is
      // what a refusal wants — the toast says which holdings still sit in the class.
      onError?.(friendlyOwnershipMessage(err));
      throw err;
    }
  };

  return (
    <DeleteConfirmationModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      isActionLoading={mutation.isPending}
      title={
        shareClass ? `Delete ${shareClass.name}?` : `Delete ${classNounLower}?`
      }
      message={`This ${classNounLower} will be removed from the entity. Anyone still holding it has to be moved to another ${classNounLower} first.`}
    />
  );
};
